<template>
  <div class="label-region">
    <div class="label-tools">
      <!-- <button
        v-for="(item, idx) in ActionTool.data"
        :class="['label-tool', { active: item.name === ActionTool.action }]"
        @click="labelToolAction(item.name)"
        :key="idx"
      >
        <icon-base v-bind="Icons[item.name]">
          <component :is="item.icon"></component>
        </icon-base>
      </button> -->
      <!-- 右上角-标注示例 -->
      <slot></slot>
    </div>
    <div class="label-area">
      <div class="label-container">
        <img
          :src="photoBaseUrl + image.imgUrl"
          alt=""
          ref="img"
          :style="{
            top: imageStyle.top + 'px',
            left: imageStyle.left + 'px',
            width: imageStyle.width + 'px',
            height: imageStyle.height + 'px'
          }"
          @load="imageLoad"
        />
        <div
          class="label-container-box"
          ref="container"
          :style="{
            top: imageStyle.top + 'px',
            left: imageStyle.left + 'px',
            width: imageStyle.width + 'px',
            height: imageStyle.height + 'px'
          }"
        >
          <div v-for="(region, index) in regionList" :key="index">
            <div
              :class="[
                'label-box',
                ActionTool.action == 'label' &&
                activeRegion == index &&
                region.myKey != 'noTarget'
                  ? 'active'
                  : ''
              ]"
              :style="{
                top: region.t + '%',
                left: region.l + '%',
                width: region.w + '%',
                height: region.h + '%'
              }"
              :data-index="index"
              @click="onActive(index)"
              v-if="region.isShow === 1"
            >
              <span class="point-drag l t nwse" data-direct="nw"></span>
              <span class="point-drag rc t ns" data-direct="n"></span>
              <span class="point-drag r t nesw" data-direct="ne"></span>
              <span class="point-drag r cc ew" data-direct="e"></span>
              <span class="point-drag r b nwse" data-direct="se"></span>
              <span class="point-drag rc b ns" data-direct="s"></span>
              <span class="point-drag l b nesw" data-direct="sw"></span>
              <span class="point-drag l cc ew" data-direct="w"></span>
              <span class="tag-label">{{ region.label }}</span>
              <span class="btn-del icon-del" @click="delLabel(index, region)"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GatPopup from "@/components/common/GatPopup";
import IconLabel from "@/components/icons/typography/ToolLabel";
import IconMove from "@/components/icons/typography/ToolMove";
import IconZoomIn from "@/components/icons/typography/ToolZoomIn";
import IconZoomOut from "@/components/icons/typography/ToolZoomOut";

export default {
  name: "label-region",
  components: { GatPopup, IconLabel, IconMove, IconZoomIn, IconZoomOut },
  props: {
    image: {
      type: Object,
      required: true
    },
    labelList: {
      type: Array,
      default: []
    },
    imgTag: {
      type: Array,
      default: []
    },
    noTarget: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC头像基地址
      selectLabel: {}, // 标签
      localRegion: [], // 缓存当前添加标注
      localPositionAll: [], // 缓存清空的所有标注
      deleteTextTagIds: [], // 缓存当前删除的标注id
      // naturalStyle: {}, // 图片的原始尺寸
      // containerStyle: {}, // 图片载入过程中设置图片自适应处理
      // 容器位置
      containerOffset: null,
      // 鼠标当前位置
      currentMousePoint: null,
      // 鼠标位置
      currentAbsoluteMousePoint: null,
      // 鼠标移动事件回调
      func: null,
      // 当前的移动样式
      currentMobileStyle: {},
      // 标注区域列表
      regionList: [
        // {
        //   containerOffset: null,
        //   label: "猫猫狗",
        //   t: 50,
        //   l: 40,
        //   w: 30,
        //   h: 20
        // }
      ],
      activeRegion: null, // 当前操作的region
      initialStyle: {
        top: 0,
        left: 0,
        width: 670,
        height: 420
      }, // 图片的初始样式
      imageStyle: null, // 图片样式
      mobileStatusStyle: null, // 移动状态下的样式
      mobileStyle: null, // 移动样式
      showMiniImage: false, // 是否显示缩略图
      enlargeCount: 1, // 0 - 4 放大次数
      regionMixSize: 20, // 区域最小尺寸
      // 初始化区域
      initialRegion: { t: void 0, l: void 0, w: void 0, h: void 0 },
      Example: {
        labelAllImg: require("../../../public/images/pretrain/example_label_all.png"),
        labelSimilarImg: require("../../../public/images/pretrain/example_label_similar.png")
      },
      Placeholder: {
        picture02: require("../../../public/images/pretrain/placeholder-picture-02.png"),
        labelImg01: require("../../../public/images/pretrain/label001.png"),
        labelImg02: require("../../../public/images/pretrain/label002.jpg")
      },
      ActionTool: {
        action: "",
        data: {
          label: {
            name: "label",
            icon: IconLabel
          }
          // ,
          // move: {
          //   name: "move",
          //   icon: IconMove
          // },
          // zoomIn: {
          //   name: "zoomIn",
          //   icon: IconZoomIn
          // },
          // zoomOut: {
          //   name: "zoomOut",
          //   icon: IconZoomOut
          // }
        }
      },
      Icons: {
        label: {
          iconName: "标注",
          viewBox: "0 0 17 17",
          width: "17",
          height: "17"
        },
        move: {
          iconName: "可移动",
          viewBox: "0 0 20 20",
          width: "20",
          height: "20"
        },
        zoomIn: {
          iconName: "缩小",
          viewBox: "0 0 20 20",
          width: "20",
          height: "20"
        },
        zoomOut: {
          iconName: "放大",
          viewBox: "0 0 20 20",
          width: "20",
          height: "20"
        }
      }
    };
  },
  computed: {
    imgTagList() {
      return this.imgTag;
    }
  },
  watch: {
    image(val) {
      let localRegionFlag = localStorage.localRegion ? true : false
      if (localRegionFlag) { // 有数据则是删除标签后缓存的未保存标注数据
        this.localRegion = JSON.parse(localStorage.localRegion)
        localStorage.localRegion = ''
      } else {
        this.localRegion = [] // 切换图片清空当前缓存标注
        this.deleteTextTagIds = []  // 清空缓存删除的标注id
      }

      if (!val.imgUrl) {
        this.localRegion = [] // 切换图片清空当前缓存标注列表
        this.localPositionAll = [] // 切换图片置空缓存清空的所有标注
        this.deleteTextTagIds = []  // 清空缓存删除的标注id
      }

      this.regionList = []; // 清空标注列表
      this.$nextTick(() => {
        var image = this.$refs.img,
          imageHeight = image.naturalHeight,
          imageWidth = image.naturalWidth,
          style = {
            width: imageWidth,
            height: imageHeight
          },
          nw = 670 / style.width,
          nh = 420 / style.height,
          n = nw > nh ? nh : nw;

        // console.log(style);

        style.width = parseInt(style.width * n, 10);
        style.height = parseInt(style.height * n, 10);
        style.top = parseInt((420 - style.height) / 2, 10);
        style.left = parseInt((670 - style.width) / 2, 10);
        style.position = "absolute";
        style.enlargeCount = 1;

        // this.style = style;

        style.enlargeCount = 1;

        this.initialStyle = style;
        // this.mobileStatusStyle = this._getBoxStyle(this.$refs.container);
        this.mobileStatusStyle = style;
        this.imageStyle = style;
      });

      this.$forceUpdate();
    },
    imgTag(imgTag) {
      // 图片加载
      this.$nextTick(() => {
        let list = []

        if (imgTag && imgTag[0] && imgTag[0].labelName && !this.noTarget) {
          list = this._parsePositionToStyle(imgTag, this.imageStyle);
        }

        this.localRegion.forEach(item => {
          item.l = Number(item.l).toFixed(3);
          item.w = Number(item.w).toFixed(3);
          item.t = Number(item.t).toFixed(3);
          item.h = Number(item.h).toFixed(3);
          // 判断位移/拉伸的标注，删除对应的已保存标注
          if (item.moveState) {
            list.forEach((r, i) => {
              if (item.imgTagId === r.imgTagId) {
                list.splice(i, 1)
              }
            });
          }
        });

        let arr = this.localRegion.concat(list);
        this.regionList = this.arrUnique(arr);

        this.regionList.forEach(item => {
          // 根据标签勾选更改标注显示隐藏状态
          this.labelList.forEach(r => {
            if (item.label === r.labelName) { // 判断当前标签对应的标注
              item.isShow = r.labelState ? 1 : 0 // 根据标签状态决定标注是否显示
            }
          });
        });

        // 从全部标注中移除当前删除的标注
        this.deleteTextTagIds.forEach(i => {
          this.regionList.forEach((r, index)=> {
            if (i == r.imgTagId) {
              this.regionList.splice(index, 1);
            }
          });
        });

        if (!this.image.imgUrl) {
          this.regionList = []
        }
        // console.log('regionList', this.regionList)
      });
    }
  },
  created() {
    this.imageStyle = this._generaterImageStyle();
    setTimeout(() => {
      this.labelToolAction('label')
    }, 1000);
  },
  mounted() {},
  methods: {
    // 外部调用传入选中标签
    addLabelSelect(val) {
      this.selectLabel = val
    },

    // 标注去重
    arrUnique(arr) {
      for (var i=0; i<arr.length; i++) {
        for (var j=i+1; j<arr.length; j++) {
          if (arr[i].label==arr[j].label && arr[i].h==arr[j].h && arr[i].l==arr[j].l && arr[i].t==arr[j].t && arr[i].w==arr[j].w) {
          // if (arr[i].imgTagId==arr[j].imgTagId && !arr[j].moveState) {
          // if (arr[i].imgTagId==arr[j].imgTagId) {
            arr.splice(j,1);
            j--;
          }
        }
      }
      return arr;
    },

    // 标注工具操作
    labelToolAction(action) {
      var toolAction = "move";
      if (action === "label") {
        toolAction = action;
        this.clearStatusMobileEvent();
        this.registerStatusLabelEvent();
      } else if (action === "move") {
        // toolAction = action;
        // TODO:移动是需要在放大情况下可用
        // TODO:暂时屏蔽
        this.clearStatusLabelEvent();
        this.registerStatusMobileEvent();
      } else if (action === "zoomOut") {
        // TODO:放大
        toolAction = "move";
        this.containerStyle = this._transformStyleMultiple(
          this.mobileStatusStyle,
          2
        );
      } else if (action === "zoomOut") {
        // TODO:缩小
        toolAction = "move";
        this.containerStyle = this._transformStyleMultiple(
          this.initialStyle,
          1
        );
      }

      this.ActionTool.action = toolAction;
    },
    // 切换到 label 状态下的事件注册
    registerStatusLabelEvent() {
      // 鼠标按下 readyDraw
      this.$refs.container.addEventListener("mousedown", this.readyDraw);
      // 鼠标离开规定区域/鼠标回升
      this.$refs.container.addEventListener("mouseleave", this.closeDrag);
      this.$refs.container.addEventListener("mouseup", this.closeDrag);
    },
    // 清除标注状态事件
    clearStatusLabelEvent() {
      this.$refs.container.removeEventListener("mouseleave", this.closeDrag);
      this.$refs.container.removeEventListener("mousedown", this.readyDraw);
      this.$refs.container.removeEventListener("mouseup", this.closeDrag);
    },
    // 注册移动状态的事件
    registerStatusMobileEvent() {
      // 鼠标按下 dragImage
      this.$refs.container.addEventListener("mousedown", this.dragImage);
      this.$refs.container.addEventListener("mouseleave", this.closeDrag2);
      this.$refs.container.addEventListener("mouseup", this.closeDrag2);
    },
    // 清除移动状态事件
    clearStatusMobileEvent() {
      this.$refs.container.removeEventListener("mousemove", this.closeDrag2);
      this.$refs.container.removeEventListener("mousedown", this.dragImage);
      this.$refs.container.removeEventListener("mouseup", this.closeDrag2);
    },
    // 绘制前准备
    readyDraw(e) {
      e.stopImmediatePropagation(); // 禁止拖动
      e.preventDefault();
      // 获取容器样式数据
      this.containerOffset = this._getBoxStyle(this.$refs.container);
      // this.containerOffset = this.$refs.container.getBoundingClientRect();
      // 记录当前鼠标落点
      this.currentMousePoint = {
        x: e.clientX - this.containerOffset.left,
        y: e.clientY - this.containerOffset.top
      };
      // 记录当前鼠标绝对落点
      this.currentAbsoluteMousePoint = {
        x: e.clientX,
        y: e.clientY // 判断鼠标落点是已经存在的矩形上 还是画布上 或是矩形的边缘
      };
      // 根据鼠标落点位置进行不同的操作
      if (e.target.classList.contains("label-container-box")) {
        // 创建新矩形
        this.createRegion(e);
      } else if (e.target.classList.contains("label-box")) {
        var index = e.target.dataset.index;
        // 要被拖动的矩形坐标
        var regon = this.regionList[index];
        if (regon && regon.myKey === "noTarget") {
          return;
        }
        // this.setState({ activeRegion: index });
        this.activeRegion = index;
        this.dragRegion(e, index);
      } else {
        // 拉伸矩形
        this.stretchRegion(e);
      }
    },
    // 关闭拖动事件，用于标注状态下的事件消除
    closeDrag(e) {
      if (e) {
        // stopImmediatePropagation 阻止事件冒泡，并阻止同类事件的其他侦听器被调用
        // stopPropagation 阻止当前事件进一步传播
        e.stopImmediatePropagation();
      }
      this._clearNoQualifieRegion();
      // 移除 mousemove 事件
      // 对 mousemove 事件的回调函数，统一协调成 this.func
      // TODO: refs未处理
      this.$refs.container.removeEventListener("mousemove", this.func);
    },
    // 关闭拖动事件方法二，用于移动状态下的事件消除标注状态
    closeDrag2(e) {
      if (e) {
        // stopImmediatePropagation 阻止事件冒泡，并阻止同类事件的其他侦听器被调用
        // stopPropagation 阻止当前事件进一步传播
        e.stopImmediatePropagation();
      }
      // 初始化样式
      this.initialStyle = null;
      // 当前可移动样式
      this.currentMobileStyle = this.mobileStyle;
      this._clearNoQualifieRegion();
      // 移除 mousemove 事件
      // 对 mousemove 事件的回调函数，统一协调成 this.func
      this.$refs.container.removeEventListener("mousemove", this.func);
    },
    // 图片拖动
    dragImage(e) {
      if (this.enlargeCount === 1) {
        return;
      }
      // 阻止事件冒泡，并阻止同类事件的其他侦听器被调用
      e.stopImmediatePropagation();
      e.preventDefault();
      // 容器位置
      this.containerOffset = this._getBoxStyle(this.$refs.container);
      // this.containerOffset = this.$refs.container.getBoundingClientRect();
      // 当前鼠标点位置
      this.currentMousePoint = { x: e.clientX, y: e.clientY };
      // 初始化样式，初始化为移动状态样式
      this.initialStyle = this.mobileStatusStyle;
      // this.func 鼠标移动事件回调，初始化为 mobileImage
      this.func = this.mobileImage;
      this.$refs.container.addEventListener("mousemove", this.func);
    },
    // 移动图片
    mobileImage(e) {
      // 图片移动
      // X 点位移
      var offsetX = e.clientX - this.currentMousePoint.x;
      // Y 点位移
      var offsetY = e.clientY - this.currentMousePoint.y;

      // 初始化样式
      var initialStyle = JSON.parse(JSON.stringify(this.mobileStatusStyle));

      // 初始化样式点
      initialStyle.top = this.initialStyle.top + offsetY;
      initialStyle.left = this.initialStyle.left + offsetX;
      // 419、669 是容器的大小边缘
      if (initialStyle.height > 419) {
        if (initialStyle.top > 0) {
          initialStyle.top = 0;
        }
        if (initialStyle.top + initialStyle.height - 420 < 0) {
          initialStyle.top = (initialStyle.height - 420) * -1;
        }
      } else {
        initialStyle.top = this.initialStyle.top;
      }
      if (initialStyle.width > 669) {
        if (initialStyle.left > 0) {
          initialStyle.left = 0;
        }
        if (initialStyle.left + initialStyle.width - 670 < 0) {
          initialStyle.left = (initialStyle.width - 670) * -1;
        }
      } else {
        initialStyle.left = this.initialStyle.left;
      }
      // 状态保存
      // this.setState({ mobileStatusStyle: initialStyle });
      this.mobileStatusStyle = initialStyle;
    },
    // 拖动区域
    dragRegion(e, index) {
      // 记录矩形初始状态
      this.initialRegion = JSON.parse(JSON.stringify(this.regionList[index]));
      this.func = this.draging.bind(this, index);
      this.$refs.container.addEventListener("mousemove", this.func);
    },
    // 拉伸标注矩形区域
    stretchRegion(e) {
      this.initialRegion = JSON.parse(
        JSON.stringify(this.regionList[this.activeRegion])
      );
      this.stretchDirect = e.target.dataset.direct; // 拉伸方向
      this.func = this.stretching; // 拉伸函数方法
      this.$refs.container.addEventListener("mousemove", this.func);
    },
    // 鼠标移动拉伸
    stretching(e) {
      var list = this.regionList; // 标注区域数组列表
      var activeRegionIndex = this.activeRegion; // 已激活的标注区域索引
      var region = list[activeRegionIndex]; // 已激活的标注区域数据
      var w = void 0,
        h = void 0;
      var t = region.t;
      var l = region.l;
      var minWidth = Number(this.regionMixSize / this.initialStyle.width) * 100; // 最小宽度
      var minHeigth =
        Number(this.regionMixSize / this.initialStyle.height) * 100; // 最小高度
      var offsetXPercen = Number(
        ((this.currentAbsoluteMousePoint.x - e.clientX) * 100) /
          this.containerOffset.width
      ); // X 偏移长度与容器 width 的百分比
      var offsetYPercen = Number(
        ((this.currentAbsoluteMousePoint.y - e.clientY) * 100) /
          this.containerOffset.height
      ); // Y 偏移长度与容器 Height 的百分比

      // 根据拉伸点位置进行不同的操作处理，并加入了边缘测试
      // 相关位置是利用 东西南北 进行排序：
      // 东(east) 北(north) 南(south) 西(west)
      // 东北(eastnorth) 西北(westnorth) 西南(westsouth) 东南(eastsouth)
      switch (this.stretchDirect) {
        case "e":
          var woffsetE = Number(this.initialRegion.w) - offsetXPercen;
          w = woffsetE > minWidth ? woffsetE : minWidth;
          w = l + w > 100 ? 100 - l : w; // 利用标注区域在 position:left; left(%) + width(%) = 100%
          break;
        case "n":
          var hoffsetN = Number(this.initialRegion.h) + offsetYPercen;
          if (hoffsetN > minHeigth) {
            h = Number(this.initialRegion.h) + offsetYPercen;
            t =
              Number(this.initialRegion.t) - offsetYPercen < 0
                ? 0
                : Number(this.initialRegion.t) - offsetYPercen;
            h = t + h > 100 ? 100 - t : h; // 利用标注区域在 position:top; top(%) + height(%) = 100%
          }
          break;
        case "s":
          var hoffsetS = Number(this.initialRegion.h) - offsetYPercen;
          if (hoffsetS > minHeigth) {
            h = Number(this.initialRegion.h) - offsetYPercen;
          }
          h = t + h > 100 ? 100 - t : h;
          break;
        case "w":
          var woffsetW = Number(this.initialRegion.w) + offsetXPercen;
          if (woffsetW > minHeigth) {
            w = woffsetW;
            l =
              Number(this.initialRegion.l) - offsetXPercen < 0
                ? 0
                : Number(this.initialRegion.l) - offsetXPercen;
            w = l + w > 100 ? 100 - l : w;
          }
          break;
        case "ne":
          var neoffsetE = Number(this.initialRegion.w) - offsetXPercen;
          w = neoffsetE > minWidth ? neoffsetE : minWidth;
          w = l + w > 100 ? 100 - l : w;
          var neoffsetN = Number(this.initialRegion.h) + offsetYPercen;
          if (neoffsetN > minHeigth) {
            h = Number(this.initialRegion.h) + offsetYPercen;
            t =
              Number(this.initialRegion.t) - offsetYPercen < 0
                ? 0
                : Number(this.initialRegion.t) - offsetYPercen;
            h = t + h > 100 ? 100 - t : h;
          }
          break;
        case "nw":
          var nwoffsetW = Number(this.initialRegion.w) + offsetXPercen;
          if (nwoffsetW > minHeigth) {
            w = nwoffsetW;
            l =
              Number(this.initialRegion.l) - offsetXPercen < 0
                ? 0
                : Number(this.initialRegion.l) - offsetXPercen;
            w = l + w > 100 ? 100 - l : w;
          }
          var nwoffsetN = Number(this.initialRegion.h) + offsetYPercen;
          if (nwoffsetN > minHeigth) {
            h = Number(this.initialRegion.h) + offsetYPercen;
            t =
              Number(this.initialRegion.t) - offsetYPercen < 0
                ? 0
                : Number(this.initialRegion.t) - offsetYPercen;
            h = t + h > 100 ? 100 - t : h;
          }
          break;
        case "sw":
          var swoffsetS = Number(this.initialRegion.h) - offsetYPercen;
          if (swoffsetS > minHeigth) {
            h = Number(this.initialRegion.h) - offsetYPercen;
            h = t + h > 100 ? 100 - t : h;
          }
          var swoffsetW = Number(this.initialRegion.w) + offsetXPercen;
          if (swoffsetW > minHeigth) {
            w = swoffsetW;
            l =
              Number(this.initialRegion.l) - offsetXPercen < 0
                ? 0
                : Number(this.initialRegion.l) - offsetXPercen;
          }
          break;
        case "se":
          var hoffsetSE = Number(this.initialRegion.h) - offsetYPercen;
          if (hoffsetSE > minHeigth) {
            h = Number(this.initialRegion.h) - offsetYPercen;
            h = t + h > 100 ? 100 - t : h;
          }
          var woffsetSE = Number(this.initialRegion.w) - offsetXPercen;
          w = woffsetSE > minWidth ? woffsetSE : minWidth;
          break;
      }
      // 探测相应 region 值是否有所改动进行 region 值替换
      region.w = w ? w : region.w;
      region.h = h ? h : region.h;
      region.t = t ? t : region.t;
      region.l = l ? l : region.l;
      region.moveState = true; // true 表示移动/拉伸了改标注

      // 标注区域数组列表内容缓存
      list[activeRegionIndex] = region;

      // 缓存全局标注区域数组列表
      // this.setState({ regionList: list });
      this.regionList = list;

      let num = null
      let flng = this.localRegion.some((item, index) => {
        if (item.imgTagId === region.imgTagId) {
          num = index
        }
        return item.imgTagId === region.imgTagId
      })
      if (flng) {
        this.localRegion.splice(num, 1, region)// 移动标注记录缓存
      } else {
        let length = this.localRegion.length
        this.localRegion.splice(length, 1, region)// 移动标注记录缓存
      }
    },
    // 拖动过程
    draging(index, e) {
      // 拖动
      var list = this.regionList; // 标注区域数组列表
      var region = list[index]; // 获取选中的标注区域数组列表
      var cx = e.clientX; // 光标移动到的点
      var px = this.currentMousePoint.x; // 光标落点
      var cy = e.clientY; // 光标移动到的点
      var py = this.currentMousePoint.y; // 光标落点
      var offsetXPercen =
        ((cx - px - this.containerOffset.left) * 100) /
        this.containerOffset.width; // X 相对于容器的位移百分比
      var offsetYPercen =
        ((cy - py - this.containerOffset.top) * 100) /
        this.containerOffset.height; // Y 相对于容器的位移百分比

      // 缓存 region 数据
      region.l =
        Number(this.initialRegion.l) + Number(offsetXPercen) < 0
          ? 0
          : Number(this.initialRegion.l) + Number(offsetXPercen);
      region.t =
        Number(this.initialRegion.t) + Number(offsetYPercen) < 0
          ? 0
          : Number(this.initialRegion.t) + Number(offsetYPercen);
      region.l =
        region.l + Number(region.w) > 100 ? 100 - Number(region.w) : region.l;
      region.t =
        region.t + Number(region.h) > 100 ? 100 - Number(region.h) : region.t;
      region.moveState = true // true 表示移动/拉伸了改标注
      list[index] = region;
      // this.setState({ regionList: list });
      this.regionList = list;

      let num = null
      let flng = this.localRegion.some((item, index) => {
        if (item.imgTagId === region.imgTagId) {
          num = index
        }
        return item.imgTagId === region.imgTagId
      })
      if (flng) {
        this.localRegion.splice(num, 1, region)// 移动标注记录缓存
      } else {
        let length = this.localRegion.length
        this.localRegion.splice(length, 1, region)// 移动标注记录缓存
      }
    },
    // 拖动区域
    drawRegion(index, e) {
      var list = this.regionList; // 标注区域数组列表
      var region = list[index]; // 按索引提取标注区域数组列表
      // 若提取的标注区域数组列表为空或未定义，则返回
      if (!region) {
        return;
      }
      // 增加边缘检测
      if (this.currentMousePoint.x <= e.clientX - this.containerOffset.left) {
        var offset =
          e.clientX - this.containerOffset.left - this.currentMousePoint.x;
        region.w = new Number(
          offset / (region.containerOffset.width / 100)
        ).toFixed(3);
      } else {
        var offsetW =
          this.currentMousePoint.x + this.containerOffset.left - e.clientX;
        var offsetL = e.clientX - this.containerOffset.left;
        region.w = new Number(
          offsetW / (region.containerOffset.width / 100)
        ).toFixed(3);
        var l = new Number(
          offsetL / (region.containerOffset.width / 100)
        ).toFixed(3);
        region.l = l < 0 ? 0 : l;
      }

      if (this.currentMousePoint.y <= e.clientY - this.containerOffset.top) {
        var offsetH =
          e.clientY - this.currentMousePoint.y - this.containerOffset.top;
        region.h = new Number(
          offsetH / (region.containerOffset.height / 100)
        ).toFixed(3);
      } else {
        var offsetT = e.clientY - this.containerOffset.top;
        var _offsetH =
          this.containerOffset.top + this.currentMousePoint.y - e.clientY;
        var t = new Number(
          offsetT / (region.containerOffset.height / 100)
        ).toFixed(3);
        region.t = t < 0 ? 0 : t;
        region.h = new Number(
          _offsetH / (region.containerOffset.height / 100)
        ).toFixed(3);
      }
      // 缓存 region 数据
      list[index] = region;
      // this.setState({ regionList: list });
      this.regionList = list;
    },
    onActive(index) {
      // 选取相应的 region 使用其 index 进行标注
      // this.setState({ activeRegion: index });
      this.activeRegion = index;
    },
    // 删除标注
    delLabel(index, region) {
      var list = this.regionList; // 标注区域数组列表
      // 缓存状态
      // this.setState({
      //   regionList: list.filter(function(r, i) {
      //     if (i === index) return false;
      //     return true;
      //   })
      // });

      // 删除当前添加的缓存标注
      this.localRegion = this.localRegion.filter(function(r, i) {
        // if (r.label == region.label && r.h == region.h && r.l == region.l && r.t == region.t && r.w == region.w) return false;
        if (r.imgTagId == region.imgTagId) return false;
        return true;
      });

      this.regionList = list.filter(function(r, i) {
        if (i === index) return false;
        return true;
      });

      this.deleteTextTagIds.push(region.imgTagId)  // 缓存当前删除的标注id
    },
    // 响应改变进行标注
    onChange(index, label) {
      var list = this.regionList;
      list[index] = label;
      // this.setState({ regionList: list });
      this.regionList = list;
    },
    // 通用图片样式获取
    _generaterImageStyle() {
      var imageStyle = void 0;
      // 不同情形下的状态判断操作
      if (this.status === 1) {
        // enlargeCount 放大次数
        if (this.enlargeCount > 1) {
          // mobileStatusStyle
          imageStyle = this.mobileStatusStyle;
        } else {
          // _toLabelImageStyle
          imageStyle = this._toLabelImageStyle(this.initialStyle);
        }
      } else {
        imageStyle =
          this.mobileStatusStyle || this._toLabelImageStyle(this.initialStyle);
      }
      return imageStyle;
    },
    // 获取盒子的样式数据
    _getBoxStyle(box) {
      var p = box.getBoundingClientRect();
      return { width: p.width, height: p.height, top: p.top, left: p.left };
    },
    // 创建可用区域
    createRegion(e) {
      if (!this.image.imgUrl) {
        return;
      }
      if (!this.selectLabel.labelName) {
        return this.$message.error('请选择标签！');
      }
      var timesId = new Date().getTime().toString();
      var x = e.clientX;
      var y = e.clientY;
      var containerOffset = JSON.parse(JSON.stringify(this.containerOffset));
      var left = x - this.containerOffset.left;
      var top = y - this.containerOffset.top;
      var currentRegion = {
        imgTagId: timesId,
        label: this.selectLabel.labelName,
        isShow: 1,
        l: new Number(left / (containerOffset.width / 100)).toFixed(3),
        t: new Number(top / (containerOffset.height / 100)).toFixed(3),
        w: new Number(1 / (containerOffset.width / 100)).toFixed(3),
        h: new Number(1 / (containerOffset.height / 100)).toFixed(3),
        containerOffset: containerOffset
      };
      var list = this.regionList;
      var index = list.length; // 创建一个矩形
      this.localRegion.push(currentRegion) // 添加当前创建未保存的标注
      list.push(currentRegion); // 关闭所有active
      var regionList = this._clearActive(list); // 记录所创建矩形的在数组中位置
      this.func = this.drawRegion.bind(this, index);
      this.$refs.container.addEventListener("mousemove", this.func);
      // this.setState({
      //   activeRegion: regionList.length - 1,
      //   regionList: regionList
      // });
      this.activeRegion = regionList.length - 1;
      this.regionList = regionList;
    },
    // 激活状态消除
    _clearActive(list) {
      return list.map(function(region) {
        if (region.isActive) {
          delete region.isActive;
        }
        return region;
      });
    },
    _clearNoQualifieRegion() {
      var list = JSON.parse(JSON.stringify(this.regionList));
      var region = list[this.activeRegion];
      if (region) {
        var minWidth =
          Number(this.regionMixSize / this.initialStyle.width) * 100;
        var minHeigth =
          Number(this.regionMixSize / this.initialStyle.height) * 100;
        if (region.w <= minWidth || region.h <= minHeigth) {
          region.w = region.w < minWidth ? minWidth : region.w;
          region.h = region.h < minHeigth ? minHeigth : region.h;
          // this.setState({ regionList: list });
          this.regionList = list;
        }
      }
    },
    // 标注容器样式数据
    _toLabelContainerStyle(style) {
      var width = style ? style.width : "";
      var height = style ? style.height : "";
      var top = style ? style.top : "";
      var left = style ? style.left : "";
      return {
        position: "relative",
        overflow: "hidden",
        width: width,
        height: height,
        top: top,
        left: left
      };
    },

    // 标注的图片样式
    _toLabelImageStyle(style) {
      var imageStyle = this._toLabelContainerStyle(style);
      delete imageStyle.overflow;
      imageStyle.position = "absolute";
      return imageStyle;
    },
    // tag 数据解析
    _parsePositionToStyle(position, style) {
      return position.map(function(p) {
        if (p.left && p.top) {
          return p;
        }
        var containerOffset = p.containerOffset || {
          width: style.width,
          height: style.height
        };
        return {
          imgTagId: p.imgTagId,
          isShow: p.isShow,
          id: p.ImgTagId,
          label: p.labelName,
          myKey:
            p.labelId === "00000000-0000-0000-0000-000000000000"
              ? "noTarget"
              : void 0,
          l: (Number(p.X1) * 100).toFixed(3),
          w: (Number(p.X2 - p.X1) * 100).toFixed(3),
          t: (Number(p.Y1) * 100).toFixed(3),
          h: (Number(p.Y2 - p.Y1) * 100).toFixed(3),
          isFromAutoRemark: p.isFromAutoRemark,
          containerOffset: containerOffset
        };
      });
    },
    // 将样式坐标代码转化为坐标比例
    _stypeToPosition(styles) {
      return styles.map(function(style) {
        return {
          isShow: style.isShow,
          imgTagId: style.imgTagId,
          label: style.label,
          labelName: style.label,
          moveState: style.moveState ? style.moveState : false,
          X1: Number(style.l / 100).toFixed(3),
          X2: Number(style.l / 100 + style.w / 100).toFixed(3),
          Y1: Number(style.t / 100).toFixed(3),
          Y2: Number(style.t / 100 + style.h / 100).toFixed(3),
          myKey: style.myKey
        };
      });
      // debugger;
    },
    // 图片放大
    _transformStyleMultiple(style, targetM) {
      // 将initstyle放大targetM - currentM 倍
      // 获取initStyle
      var mixTop = this.initialStyle.top;
      var mixLeft = this.initialStyle.left;
      var currentM = style.enlargeCount || 1;
      var width = void 0,
        height = void 0,
        top = void 0,
        left = void 0;
      width = (style.width / currentM) * targetM;
      height = (style.height / currentM) * targetM;
      var maxLeft = this.initialStyle.left + this.initialStyle.width - width;
      var maxTop = this.initialStyle.top + this.initialStyle.height - height;
      top = style.top - (this.initialStyle.height / 2) * (targetM - currentM);
      left = style.left - (this.initialStyle.width / 2) * (targetM - currentM);
      if (top < maxTop) {
        top = maxTop;
      }
      if (top > mixTop) {
        top = mixTop;
      }
      if (left < maxLeft) {
        left = maxLeft;
      }
      if (left > mixLeft) {
        left = mixLeft;
      }
      if (height < 420) {
        top = (420 - height) / 2;
      }
      if (width < 670) {
        left = (670 - width) / 2;
      }
      return {
        width: width,
        height: height,
        top: top,
        left: left,
        display: "block",
        position: "absolute",
        userSelect: "none",
        enlargeCount: targetM
      };
    },
    // 计算编辑状态盒子样式
    _computerEditBoxStyle(style) {
      var width = style ? style.width : "";
      var height = style ? style.height : "";
      var top = style ? style.top : "";
      var left = style ? style.left : "";
      return {
        position: "absolute",
        width: width * this.state.enlargeCount,
        height: height * this.state.enlargeCount,
        top: top - (height / 2) * (this.state.enlargeCount - 1),
        left: left - (width / 2) * (this.state.enlargeCount - 1)
      };
    },

    // 外部调用
    stypeToPosition() {
      var styles = this.regionList.concat(this.localRegion),
        arr = this._stypeToPosition(styles),
        positions = this.unique(arr);

      this.localRegion = [] // 保存标注后清空缓存标注
      return positions;
    },
    // 标注去重
    unique(arr) {
      for (var i=0; i<arr.length; i++) {
        for (var j=i+1; j<arr.length; j++) {
          if (arr[i].label==arr[j].label && arr[i].X1==arr[j].X1 && arr[i].X2==arr[j].X2 && arr[i].Y1==arr[j].Y1 && arr[i].Y2==arr[j].Y2) {
            arr.splice(j,1);
            j--;
          }
        }
      }
      return arr;
    },
    // 清空标注
    emptyTagRegion(val) {
      if (val.indexOf("无目标") !== -1) { // 清空标注
        let arr = this.localRegion.concat(this.regionList);
        arr = this.arrUnique(arr);
        this.localPositionAll = JSON.parse(JSON.stringify(arr)) // 缓存清空的所有标注

        this.regionList = [];
        this.localRegion = [];
      } else { // 还原清空的标注
        let arr = this.localRegion.concat(this.localPositionAll); // 清空的所有标注+当前添加的标注
        this.regionList = this.arrUnique(arr); // 还原清空的所有标注
        this.localRegion = JSON.parse(JSON.stringify(this.regionList)) // 同步当前缓存的标注列表
        this.localPositionAll = []

        this.regionList.forEach(item => {
          // 根据标签勾选更改标注显示隐藏状态
          this.labelList.forEach(r => {
            if (item.label === r.labelName) { // 判断当前标签对应的标注
              item.isShow = r.labelState ? 1 : 0 // 根据标签状态决定标注是否显示
            }
          });
        });
      }
      // 外部调用，使用 $refs 不是响应式系统，需要进行强制更新
      this.$forceUpdate();
    },

    // 把标签添加到当前区域
    addTagToCurrentRegion(labelName) {
      var list = this.regionList,
        index = this.activeRegion,
        hasNotarget = false;

      // TODO:图片不存在
      if (this.image <= 0) {
        return;
      }

      if (labelName.indexOf("无目标") > -1) {
        hasNotarget = list.some(item => item.myKey === "noTarget");
        index = 0;
        if (hasNotarget) {
          list = [];
        } else {
          list = [
            // {
            //   isShow: 1,
            //   w: 100,
            //   h: 100,
            //   t: 0,
            //   l: 0,
            //   myKey: "noTarget",
            //   label: "无目标"
            // }
          ];
        }
      } else {
        // 当前区域为无目标设置，不能继续工作
        // if (list[index].myKey && list[index].myKey === "noTarget") {
        //   return;
        // }

        // 需要先划分区域与选中才能继续操作
        if (!list || index == null) {
          return;
        }
        list[index].label = labelName;
      }

      this.regionList = list;
      // 外部调用，使用 $refs 不是响应式系统，需要进行强制更新
      this.$forceUpdate();
    },
    // 标签重命名
    renameRegionLabel(newlabelName, oldlabelName) {
      // 修改返回标注列表中的标签名
      var list = JSON.parse(JSON.stringify(this.regionList)),
        newList = list.map(region => {
          var temp = region;
          if (region.label === oldlabelName) {
            region.label = newlabelName;
          }
          return temp;
        });
      this.regionList = newList;

      // 同步修改缓存当前标注列表中的标签名
      var localRegion = JSON.parse(JSON.stringify(this.localRegion)),
        regionList = localRegion.map(region => {
          var temp = region;
          if (region.label === oldlabelName) {
            region.label = newlabelName;
          }
          return temp;
        });
      this.localRegion = regionList;

      // 同步修改清空标注列表中的标签名
      var localPositionAll = JSON.parse(JSON.stringify(this.localPositionAll)),
        localList = localPositionAll.map(region => {
          var temp = region;
          if (region.label === oldlabelName) {
            region.label = newlabelName;
          }
          return temp;
        });
      this.localPositionAll = localList;

      // 外部调用，使用 $refs 不是响应式系统，需要进行强制更新
      this.$forceUpdate();
    },
    // 标签删除
    deleteRegionLabel(removelabelName) {
      // 删除返回标注列表中的标注
      var list = JSON.parse(JSON.stringify(this.regionList)),
        newList = list.filter(region => {
          var temp = region;
          if (region.label !== removelabelName) {
            return temp;
          }
        });
      this.regionList = newList;

      // 同步删除缓存当前标注列表中的标注
      var localRegion = JSON.parse(JSON.stringify(this.localRegion)),
        regionList = localRegion.filter(region => {
          var temp = region;
          if (region.label !== removelabelName) {
            return temp;
          }
        });
      this.localRegion = regionList;

      // 同步删除缓存清空标注列表中的标注
      var localPositionAll = JSON.parse(JSON.stringify(this.localPositionAll)),
        localList = localPositionAll.filter(region => {
          var temp = region;
          if (region.label !== removelabelName) {
            return temp;
          }
        });
      this.localPositionAll = localList;

      localStorage.localRegion = JSON.stringify(regionList) // 未保存的标注中缓存未删除的标注
      // 外部调用，使用 $refs 不是响应式系统，需要进行强制更新
      this.$forceUpdate();
    },
    // 图片加载后，尺寸调整
    // TODO:可以使用从外部传入的方案，但是需要改动代码，初次不做传入操作
    imageLoad() {
      var image = this.$refs.img,
        imageHeight = image.naturalHeight,
        imageWidth = image.naturalWidth,
        style = {
          width: imageWidth,
          height: imageHeight
        },
        nw = 670 / style.width,
        nh = 420 / style.height,
        n = nw > nh ? nh : nw;

      // console.log(style);

      style.width = parseInt(style.width * n, 10);
      style.height = parseInt(style.height * n, 10);
      style.top = parseInt((420 - style.height) / 2, 10);
      style.left = parseInt((670 - style.width) / 2, 10);
      style.position = "absolute";
      style.enlargeCount = 1;

      // this.style = style;

      style.enlargeCount = 1;

      this.initialStyle = style;
      // this.mobileStatusStyle = this._getBoxStyle(this.$refs.container);
      this.mobileStatusStyle = style;
      this.imageStyle = style;
    }
  }
};
</script>

<style lang="scss" scoped>
// 小圆点
$point: 6px;
$offset_point: -4px;

.label-region {
  box-sizing: border-box;
  width: 710px;
  height: 500px;
  padding: 20px;
  outline: 1px solid #dde5f7;
  box-shadow: 0px 4px 10px 0px rgba(255, 255, 255, 0.1);
  &.events-disable{
    opacity:1;
  }
}
.label-tools {
  overflow: hidden;
  margin: -5px 0 0 -5px;
  button {
    padding: 0;
    border: 0 none;
    outline: 0 none;
    background-color: transparent;
    cursor: pointer;
  }
  .label-tool {
    width: 30px;
    height: 30px;
    padding: 5px;
    margin-right: 10px;
  }
  .label-example {
    float: right;
    color: $active_color;
    line-height: 30px;
  }
}
.label-area {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  width: 670px;
  height: 420px;
  // TODO:暂用
  background-color: rgba(51, 51, 51, 0.1);
  .label-container {
    overflow: hidden;
    position: relative;
    width: 670px;
    height: 420px;
    img {
      position: absolute;
      max-width: initial;
      max-height: initial;
    }
    .label-container-box {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      .label-box {
        position: absolute;
        // top: 50%;
        // left: 40%;
        // width: 30%;
        // height: 20%;
        background-color: rgba(63, 127, 255, 0.3);
        user-select: none;
        .point-drag {
          display: none;
          position: absolute;
          width: $point;
          height: $point;
          border-radius: 50%;
          background-color: #fff;
          &.t {
            top: $offset_point;
          }
          &.r {
            right: $offset_point;
          }
          &.b {
            bottom: $offset_point;
          }
          &.l {
            left: $offset_point;
          }
          &.rc {
            right: 0;
            left: 0;
            margin: 0 auto;
          }
          &.cc {
            top: 0;
            bottom: 0;
            margin: auto;
          }
          &.nesw {
            cursor: nesw-resize;
          }
          &.nwse {
            cursor: nwse-resize;
          }
          &.ns {
            cursor: ns-resize;
          }
          &.ew {
            cursor: ew-resize;
          }
        }
        .tag-label {
          display: inline-block;
          padding: 0.25em;
          background-color: #3f7fff;
          color: $font_white;
          &:empty {
            display: none;
          }
        }
        .btn-del {
          display: none;
          position: absolute;
          right: 2px;
          bottom: 4px;
          width: 16px;
          height: 16px;
          cursor: pointer;
          &.icon-del {
            background: url("../../../public/images/ico_trash.png") no-repeat;
            background-size: contain;
          }
        }
        &.active {
          outline: 1px solid $active_color;
          .point-drag {
            display: block;
          }
          .btn-del {
            display: block;
          }
        }
      }
    }
  }
}
</style>
